import { QueryClient } from '@tanstack/react-query'

/**
 * One QueryClient, exported so non-React code (the answer save path) can refetch
 * the config bundle without being handed the client through props.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // One retry only. A participant on a phone would rather see "try again"
      // than watch a spinner grind through five attempts.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      // Answer saves are upserts, so a retry is safe, but a failed save must
      // surface immediately rather than silently retrying behind the screen.
      retry: 0,
    },
  },
})
